<template>
    <div class="container-fluid">
        <div class="row d-flex justify-content-center mt-2">
		    <div class="col-12">
            <div class="alert alert-primary text-center h4">
                <linkto :link="'/'" v-if="page == 'customer'"/>
                <linkto :link="'/orders/new_order/customer'" v-if="page != 'customer'"/>
                Új rendelés rögzítés
            </div>
				</div>
            <div class="col-12">
				<router-view/>
		    </div>
        </div>
    </div>
</template>

<script type="text/javascript">
export default {
  	computed: {
		page(){
            return this.$route.path.split('/').pop()
		}
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/orders/new_order/new_order.vue